import { Base } from "./Base";

const SESSION_STORAGE_KEY = "filterRootUrl";

const selectors = {
  tab: ".tabs__tab-link",
  detail: ".tabs__tab-detail",
};

export class Tabs extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    this.setActive = this.element.dataset.setActive;
    this.cacheNodes();
    if (this.tabs.length) {
      this.bindEventListeners();
      this.setEventListeners();
      this.constructState();
      if (!this.setActive) {
        this.setActiveTab();
      }
    }
  }

  cacheNodes() {
    this.tabs = this.element.querySelectorAll(selectors.tab);
    this.details = this.element.querySelectorAll(selectors.detail);
  }

  bindEventListeners() {
    this.handleClick = this.handleClick.bind(this);
  }

  setEventListeners() {
    this.element.addEventListener("click", this.handleClick);
  }

  constructState() {
    const _this = this;
    this.state = {
      _active: this.tabs[0].dataset.ref,
      set active(ref) {
        this._active = ref;
        _this.setActiveTab();
      },
      get active() {
        return this._active;
      },
    };
  }

  handleClick(e) {
    const rootUrl = sessionStorage.getItem(SESSION_STORAGE_KEY);
    if (e.target.classList.contains("active") && rootUrl) {
      window.location = rootUrl;
      return;
    }

    if (e.target.closest(selectors.tab)) {
      this.state.active = e.target.dataset.ref;
    }
  }

  setActiveTab() {
    const active = this.state.active;

    this.tabs.forEach((tab) => {
      const ref = tab.dataset.ref;
      if (ref === active) {
        tab.classList.add("active");
      } else {
        tab.classList.remove("active");
      }
    });

    this.details.forEach((detail) => {
      const ref = detail.dataset.ref;
      if (ref === active) {
        detail.classList.add("active");
      } else {
        detail.classList.remove("active");
      }
    });
  }
}
